import axios from 'axios';

const hostname = window.location && window.location.hostname;

const base = hostname.includes('localhost')
  ? 'https://secure-dev.republicfinance.com' //Local API Connection
  : `https://${hostname}`;

export function createAxiosInstance() {
  return axios.create({
    baseURL: `${base}/enrollment/api`,
    withCredentials: false,
  });
}

export default createAxiosInstance();
